// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__15feX","insightsList":"newBusinessInsightsMenu_insightsList__2O0tl","active":"newBusinessInsightsMenu_active__uIou4"};